module.exports = __webpack_public_path__ + "05a15efbdff2579d6fc0bdaa0fd8db.png";